const config = {
    API_URL: window.__RUNTIME_CONFIG__.REACT_APP_API_URL,
    OAUTH_REDIRECT_URL: window.__RUNTIME_CONFIG__.REACT_APP_OAUTH_REDIRECT_URL,
    ARRANGEMENT_TYPE_TYPES: ['FREE_TEXT', 'NUMBER', 'SELECTION', 'SELECTION_MULTIPLE', 'LIST', 'FILE'],
};

export default config;
